import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["plan", "powerMarketField", "powerMarketSelect", "powerMarketPlaceholder", "powerMarketHidden"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (!this.hasPowerMarketFieldTarget) return;

    const isDynamic = this.planTarget.value === "dynamic";

    if (isDynamic) {
      this.powerMarketFieldTarget.classList.remove("hidden");
      if (this.hasPowerMarketPlaceholderTarget) {
        this.powerMarketPlaceholderTarget.classList.add("hidden");
      }
      if (this.hasPowerMarketHiddenTarget) {
        this.powerMarketHiddenTarget.disabled = true;
      }
    } else {
      this.powerMarketFieldTarget.classList.add("hidden");
      if (this.hasPowerMarketPlaceholderTarget) {
        this.powerMarketPlaceholderTarget.classList.remove("hidden");
      }
      if (this.hasPowerMarketHiddenTarget) {
        this.powerMarketHiddenTarget.disabled = false;
      }
      if (this.hasPowerMarketSelectTarget) {
        this.powerMarketSelectTarget.value = "";
      }
    }
  }
}
